import { ContentfulModel } from '@/types/contentful'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type ContentfulState = {
  whatsNew: ContentfulModel | null
  privacyPolicy: ContentfulModel | null
  termsAndConditions: ContentfulModel | null
}

const initialState: ContentfulState = {
  whatsNew: null,
  privacyPolicy: null,
  termsAndConditions: null,
}

const contentfulSlice = createSlice({
  name: 'contentful',
  initialState,
  reducers: {
    setWhatsNew(state, action: PayloadAction<ContentfulModel | null>) {
      state.whatsNew = action.payload
    },
    updateWhatsNew(state, action: PayloadAction<Partial<ContentfulModel>>) {
      if (state.whatsNew) {
        state.whatsNew = { ...state.whatsNew, ...action.payload }
      }
    },
    setPrivacyPolicy(state, action: PayloadAction<ContentfulModel | null>) {
      state.privacyPolicy = action.payload
    },
    updatePrivacyPolicy(
      state,
      action: PayloadAction<Partial<ContentfulModel>>
    ) {
      if (state.privacyPolicy) {
        state.privacyPolicy = { ...state.privacyPolicy, ...action.payload }
      }
    },
    setTermsAndConditions(
      state,
      action: PayloadAction<ContentfulModel | null>
    ) {
      state.termsAndConditions = action.payload
    },
    updateTermsAndConditions(
      state,
      action: PayloadAction<Partial<ContentfulModel>>
    ) {
      if (state.termsAndConditions) {
        state.termsAndConditions = {
          ...state.termsAndConditions,
          ...action.payload,
        }
      }
    },
  },
})

export const {
  setWhatsNew,
  updateWhatsNew,
  setPrivacyPolicy,
  updatePrivacyPolicy,
  setTermsAndConditions,
  updateTermsAndConditions,
} = contentfulSlice.actions

export default contentfulSlice.reducer
